import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "admin-login"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "contain"
};
const _hoisted_4 = {
  class: "header"
};
const _hoisted_5 = {
  class: "content"
};
import { ref } from "vue";
import { Lock, UserFilled } from "@element-plus/icons-vue";
import { httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import FooterBar from "@/components/FooterBar.vue";
import { setAdminToken } from "@/store/session";
import { checkAdminSession, getSystemInfo } from "@/store/cache";
import Captcha from "@/components/Captcha.vue";
export default {
  __name: 'Login',
  setup(__props) {
    const router = useRouter();
    const title = ref("LEHE-AI Console");
    const username = ref(process.env.VUE_APP_ADMIN_USER);
    const password = ref(process.env.VUE_APP_ADMIN_PASS);
    const logo = ref("");
    const enableVerify = ref(false);
    const captchaRef = ref(null);
    checkAdminSession().then(() => {
      router.push("/admin");
    }).catch(() => {});

    // 加载系统配置
    getSystemInfo().then(res => {
      title.value = res.data.admin_title;
      logo.value = res.data.logo;
      enableVerify.value = res.data["enabled_verify"];
    }).catch(e => {
      ElMessage.error("加载系统配置失败: " + e.message);
    });
    const login = function () {
      if (username.value === "") {
        return ElMessage.error("请输入用户名");
      }
      if (password.value === "") {
        return ElMessage.error("请输入密码");
      }
      if (enableVerify.value) {
        captchaRef.value.loadCaptcha();
      } else {
        doLogin({});
      }
    };
    const doLogin = function (verifyData) {
      httpPost("/admin/login", {
        username: username.value.trim(),
        password: password.value.trim(),
        key: verifyData.key,
        dots: verifyData.dots,
        x: verifyData.x
      }).then(res => {
        setAdminToken(res.data.token);
        router.push("/admin");
      }).catch(e => {
        ElMessage.error("登录失败，" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", null, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "bg"
      }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/'))
      }, [_createVNode(_component_el_image, {
        src: logo.value,
        fit: "cover"
      }, null, 8, ["src"])]), _createElementVNode("h1", _hoisted_4, "登录 " + _toDisplayString(title.value), 1), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
        modelValue: username.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => username.value = $event),
        placeholder: "请输入用户名",
        size: "large",
        autocomplete: "off",
        autofocus: "",
        onKeyup: _withKeys(login, ["enter"])
      }, {
        prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(UserFilled))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: password.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => password.value = $event),
        placeholder: "请输入密码",
        size: "large",
        "show-password": "",
        autocomplete: "off",
        onKeyup: _withKeys(login, ["enter"])
      }, {
        prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Lock))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_row, {
        class: "btn-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          class: "login-btn",
          size: "large",
          type: "primary",
          onClick: login
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("登录")])),
          _: 1
        })]),
        _: 1
      })])]), enableVerify.value ? (_openBlock(), _createBlock(Captcha, {
        key: 0,
        onSuccess: doLogin,
        ref_key: "captchaRef",
        ref: captchaRef
      }, null, 512)) : _createCommentVNode("", true), _createVNode(FooterBar, {
        class: "footer"
      })])])]);
    };
  }
};